(function () {
    'use strict';
    angular.module('tmx-app')
        .controller('roleManagementEditCtrl', ['$scope', 'resolvedData', '$state', 'tmxUtility', '$location', '$anchorScroll', 'TmxDialogService','ToastService', 
            function RoleManagementEditCtrl($scope, resolvedData, $state, tmxUtility, $location, $anchorScroll,TmxDialogService,ToastService) {

        //#region  INITIALIZATIONS
        /////////////////INITIALIZATIONS///////////////////////////////////////////////////////////////////////////////////////
                var menuHiddenPrivileges = ["Approve", "Verify"];
                var allowedFieldPrivileges = ["View"];
                var roleVM = this;
                var exists = tmxUtility.exists;
                $scope.dataLoading = false;
                roleVM.readonly = false;
                roleVM.selected = false;
                roleVM.selectedTab = 0;
                roleVM.MasterEntities = [];
                roleVM.MasterPrivileges = [];
                roleVM.MenuEntities = [];
                roleVM.MenuPrivileges = [];
                roleVM.FieldEntities = []; 
                roleVM.FieldPrivileges = [];
                roleVM.ReportEntities = [];
                roleVM.ReportPrivileges = [];

                roleVM.Selectedprivileges = [];

        //////////////////////////DATE TIME PICKER CONFIGURATIONS/////////////////////
                roleVM.currentdateObj = tmxUtility.setStartDate(new Date());
                roleVM.date = roleVM.currentdateObj.toJSON();
                roleVM.StartDateReadonly = false;
                roleVM.EndDateReadonly = false;
                roleVM.StartDateInvalid = false;
                roleVM.EndDateInvalid = false;

        ///////////////// SETTING READONLY BASED ON DATA.INFO FROM $STATE paramter passed in from parent state/////////////////

                roleVM.StateInfo = JSON.parse(localStorage.getItem("ViewState"));
                //first time view
                if ($state.data.info == true || roleVM.StateInfo == true){
                    roleVM.readonly = true;
                    roleVM.StartDateReadonly = true;
                    roleVM.EndDateReadonly = true;
                }

        //#endregion

        //#region  Page Initialization Funtions
                function InitializePage() {
                    setPageState();
                    populateResolveData();
                    populateEntities();
                    initializePrevileges();
                    populateRoles();
                }
                function populateResolveData() {
                    if (angular.isDefined(resolvedData.Entities.data)) {
                        roleVM.entityCombinedList = resolvedData.Entities.data.Data;
                    }
                    else { roleVM.entityCombinedList = []; }
                    roleVM.Privileges = resolvedData.Privileges ? resolvedData.Privileges.data : [];
                    roleVM.Role = exists(resolvedData.Role,'data') ? resolvedData.Role.data : resolvedData.Role;
                }

                function populateEntities() {

                    if (!angular.isDefined(roleVM.entityCombinedList) || roleVM.entityCombinedList == null || roleVM.entityCombinedList == []) {
                //hardcoded default
                        roleVM.MasterEntities = [];
                    }
                    else {
                        roleVM.MasterEntities = [];
                        roleVM.MenuEntities = [];
                        for (var e = 0; e < roleVM.entityCombinedList.length; e++) {
                            var entity = roleVM.entityCombinedList[e];
                            entity.name = entity.EntityName;// .replace(/([A-Z])/g, ' $1').trim();
                            entity.entityId = entity.EntityId;
                            entity.isChecked = false;
                            entity.privileges = [];

                            if (entity.EntityTableName && entity.EntityTableName.toLowerCase() == "menu") {//Loan App
                                entity.entityType = "Menu";
                                roleVM.MenuEntities.push(entity);
                            }
                            else if(entity.EntityTableName && entity.EntityTableName.toLowerCase() == "field") {
                                entity.entityType = "Field";
                                roleVM.FieldEntities.push(entity);
                            }
                            else if(entity.EntityTableName && entity.EntityTableName.toLowerCase() == "report") {
                                entity.entityType = "Report";
                                roleVM.ReportEntities.push(entity);
                            }
                            else {//role management
                                entity.entityType = "MasterData";
                                roleVM.MasterEntities.push(entity)
                            }
                        }
                    }

                }

                function setPageState() {
            ///////check if edit OR add/////////
                    roleVM.edit = false;
                    if ($state.current.name.indexOf(".add") < 0) {

                        roleVM.edit = true;
                    }
                    roleVM.StartDateReadonly = roleVM.edit;

                    if(exists(resolvedData.Requests,'data.RequestId')) {
                        roleVM.readonly = true;
                        roleVM.StartDateReadonly = true;
                        roleVM.EndDateReadonly = true;       
                        TmxDialogService.showAlertDialog('Alert','A modification request is already submitted for this role. You cannot make changes until the request is Approved/Rejected.');
                    }

                }

                function initializePrevileges() {
            /////////////////////PRIVILEGE INITIALIZATION DEFAULT ADD and EDIT BOTH/////////////////////////////////////////
            //populating Master privileges array //
                    roleVM.Privileges.sort(function (a, b) { return parseFloat(a.PrivilegeID) - parseFloat(b.PrivilegeID) });

                    for (let i = 0; i < roleVM.Privileges.length; i++) {
                        roleVM.Privileges[i].PrivilegesValue = false;//setting value to false for all master privileges
                        roleVM.Privileges[i].EntityCount = 0;
                        roleVM.MasterPrivileges.push(angular.copy(roleVM.Privileges[i]));
                        if (menuHiddenPrivileges.indexOf(roleVM.Privileges[i].PrivilegeName) <= -1) { // If the current previlege is not supposed to be hidden then push it
                            roleVM.MenuPrivileges.push(angular.copy(roleVM.Privileges[i])); //populate Transaction Privileges
                        }
                        if(allowedFieldPrivileges.indexOf(roleVM.Privileges[i].PrivilegeName)>-1){
                            roleVM.FieldPrivileges.push(angular.copy(roleVM.Privileges[i]));
                            roleVM.ReportPrivileges.push(angular.copy(roleVM.Privileges[i]));
                        }
                    }
            //populating privileges array in Master Entities//
                    for (let i = 0; i < roleVM.MasterEntities.length; i++) {
                        roleVM.MasterEntities[i].privileges = angular.copy(roleVM.MasterPrivileges);
                    }
            //populating privileges array in Transaction Entities//
                    for (let i = 0; i < roleVM.MenuEntities.length; i++) {
                        roleVM.MenuEntities[i].privileges = angular.copy(roleVM.MenuPrivileges);
                    }
                    for (let i = 0; i < roleVM.FieldEntities.length; i++) {
                        roleVM.FieldEntities[i].privileges = angular.copy(roleVM.FieldPrivileges);
                    }
                    for (let i = 0; i < roleVM.ReportEntities.length; i++) {
                        roleVM.ReportEntities[i].privileges = angular.copy(roleVM.ReportPrivileges);
                    }
                    roleVM.MasterEntitiesSource = angular.copy(roleVM.MasterEntities);
                    roleVM.MenuEntitiesSource = angular.copy(roleVM.MenuEntities);
                    roleVM.FieldEntitiesSource = angular.copy(roleVM.FieldEntities);
                    roleVM.ReportEntitiesSource = angular.copy(roleVM.ReportEntities);


            ///////////////////////////////// PRIVILEGE INITIALIZATIONS END////////////////////////////////////////////////////////
                }
                function populateRoles() {
            ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            //POPULATING DATA INTO LOCAL VARIABLES FROM RoleManagementService based on EDIT or ADD////////////////////////////////
                    if (roleVM.edit) {
                        populatePrivileges();
                        roleVM.Role.EffectiveStartDate = tmxUtility.setStartDate(roleVM.Role.EffectiveStartDate).toJSON();
                        roleVM.Role.EffectiveEndDate = tmxUtility.setEndDate(roleVM.Role.EffectiveEndDate).toJSON();
                        roleVM.minEndDate = roleVM.Role.EffectiveStartDate;
                    }
                    else { //ADD
                        roleVM.Role.PrivilegeIdsPerEntity = [];
                        roleVM.Role.EffectiveStartDate = roleVM.date;//todays JSON date with 00:00:00 time
                        roleVM.Role.EffectiveEndDate = tmxUtility.setEndDate(undefined).toJSON();//invalid date
                        roleVM.minEndDate = roleVM.Role.EffectiveStartDate;
                    }
                }

                InitializePage();

        //#endregion


        ///////////////////////CANCEL BUTTON FORM AT ANY TIME//////////////////////////////////////////////////////////////////
                roleVM.cancel = function () {
                    roleVM.Role = {};//reset the role information
                    $state.searchClear = true;
                    $state.go("^");
                };
        /////////////////////////////  FORM VALIDATION ERRORS//////////////////////////////////////////////////////////////////
                roleVM.getFormErrors = function () {

                    if (angular.isDefined(roleVM.dialogForm)) {
                        if (roleVM.dialogForm.$invalid || roleVM.Role.EffectiveEndDate == "Invalid Date") {

                            return roleVM.dialogForm.$error;
                        }
                    }
                    return undefined;
                };
        /////////////////////////////////////////////////////////////////////////////////////
                roleVM.getDateErrors = function () {
                    return roleVM.Role.EffectiveEndDate;
                };
        /////////////////////////////////////////////////////////////////////////////////////
                roleVM.getPrivilegeErrors = function () {
                    return roleVM.validationMasterPrivilege;
                };
        ////////////////////////////////////////////////////////////////////////////
                roleVM.errorChanged = function (newErrors, oldErrors) {
                    if (newErrors != oldErrors || !angular.isDefined(roleVM.Role.EffectiveEndDate) ||
                roleVM.Role.EffectiveEndDate == "Invalid Date" || roleVM.Role.EffectiveEndDate == null ||
                !roleVM.validationMasterPrivilege) {
                        roleVM.dirtyFormControls = [];
                        angular.forEach(roleVM.dialogForm, function (value) {
                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                        (typeof value === 'object' && value.$viewValue == "Invalid Date")) {
                                if (value.$name == "Effective End Date") {
                                    roleVM.EndDateInvalid = true;
                                }

                                roleVM.dirtyFormControls.push(value.$name);
                            }
                        });
                        if (!roleVM.validationMasterPrivilege) {
                            roleVM.dirtyFormControls.push("Privileges");
                        }
                        roleVM.error_msg = "Required field(s): ";
                        for (let i = 0; i < roleVM.dirtyFormControls.length; i++) {
                            if (i == roleVM.dirtyFormControls.length - 1) {
                                roleVM.error_msg += roleVM.dirtyFormControls[i];
                            }
                            else {
                                roleVM.error_msg += roleVM.dirtyFormControls[i] + ", ";
                            }
                        }//for end
                    }
                };
        //////////////////////////////////////////////////////////////////////////////
                $scope.$watch(roleVM.getFormErrors, roleVM.errorChanged, true);
                $scope.$watch(roleVM.getDateErrors, roleVM.errorChanged, true);
                $scope.$watch(roleVM.getPrivilegeErrors, roleVM.errorChanged, true);
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ///////////////////////////////SAVING ANSWER //////////////////////////////////////////////////////////////////////////
                roleVM.save = function (action, form) {
                    $scope.dataLoading = true;
                    roleVM.formSubmitted = true;
                    roleVM.bypassForm = false;
                    roleVM.errorCount = 0;
                    roleVM.formError = false;
            //Privilege Check//

                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                    if (form.$invalid || roleVM.Role.EffectiveEndDate == "Invalid date" || roleVM.Role.EffectiveEndDate == null ||
                !roleVM.validationMasterPrivilege
                    ) {

                        roleVM.dirtyFormControls = [];
                        roleVM.formInvalid = true;
                        $scope.dataLoading = false;

                        angular.forEach(form, function (value) {

                            if ((typeof value === 'object' && value.hasOwnProperty('$modelValue') && value.$invalid) ||
                        (typeof value === 'object' && value.$viewValue == "Invalid date")) {


                                value.$setTouched();
                                roleVM.errorCount++;
                                roleVM.formError = true;
                                roleVM.dirtyFormControls.push(value.$name);

                            }
                        });

                        if (!roleVM.validationMasterPrivilege) {
                            roleVM.errorCount++;
                            roleVM.formError = true;
                            roleVM.dirtyFormControls.push("Privileges");
                        }

                        if (roleVM.errorCount <= 0 && !roleVM.formError)
                            roleVM.bypassForm = true;
                    }
                    else {

                        roleVM.bypassForm = true;

                    }
            ////////////////////////////////////////////////////////
                    if (!roleVM.bypassForm) {
                        roleVM.error_msg = "Required field(s): ";
                        for (let i = 0; i < roleVM.dirtyFormControls.length; i++) {
                            if (i == roleVM.dirtyFormControls.length - 1) {
                                roleVM.error_msg += roleVM.dirtyFormControls[i];
                            }
                            else {
                                roleVM.error_msg += roleVM.dirtyFormControls[i] + ", ";
                            }
                        }
                        $location.hash('error');
                        $anchorScroll.yOffset = 600;
                // call $anchorScroll()
                        $anchorScroll();
                    }
                    else {

                        roleVM.Role.PrivilegeIdsPerEntity = [];
                        roleVM.Selectedprivileges = [];
                ///////////////////////////MASTER ENTITY PRIVILEGE//////////////////////////////////////////////////////
                        var selected = {
                            EntityId: "",
                            PrivilegeIds: []

                        };
                        var pCount = 0;
                
                        //traversing Master entity Grid and pushing Selected privileges to SelectedList//
                        for (let i = 0; i < roleVM.MasterEntitiesSource.length; i++) {
                            var entity = roleVM.MasterEntitiesSource[i];
                            selected.EntityId = angular.copy(entity.entityId);
                            selected.PrivilegeIds = [];
                            pCount = 0;//setting privilege count to 0
                    //adding privileges and incrementing counter
                            for (let j = 0; j < entity.privileges.length; j++) {
                                if (entity.privileges[j].PrivilegesValue == true) {
                                    selected.PrivilegeIds.push(entity.privileges[j].PrivilegeID);
                                    pCount = pCount + 1;
                                }
                            }

                            if (pCount != 0) {//at-least 1  privilege for this entity exists
                                roleVM.Selectedprivileges.push(angular.copy(selected));
                            }
                        }
                //////////////////////////TRANSACTION ENTITY PRIVILEGE///////////////////////////////////////////////////
                //traversing Transaction entity Grid and pushing Selected privileges to SelectedList//

                        for (let k = 0; k < roleVM.MenuEntities.length; k++) {
                            var transactionEntity = roleVM.MenuEntities[k];
                            selected.EntityId = angular.copy(transactionEntity.entityId);
                            selected.PrivilegeIds = [];
                            pCount = 0;//setting privilege count to 0
                    //adding privileges and incrementing counter
                            for (var l = 0; l < transactionEntity.privileges.length; l++) {
                                if (transactionEntity.privileges[l].PrivilegesValue == true) {
                                    selected.PrivilegeIds.push(transactionEntity.privileges[l].PrivilegeID);
                                    pCount = pCount + 1;
                                }
                            }

                            if (pCount != 0) {//at-least 1  privilege for this entity exists
                                roleVM.Selectedprivileges.push(angular.copy(selected));
                            }
                        }

                        for (let k = 0; k < roleVM.FieldEntities.length; k++) {
                            var fieldEntity = roleVM.FieldEntities[k];
                            selected.EntityId = angular.copy(fieldEntity.entityId);
                            selected.PrivilegeIds = [];
                            pCount = 0;//setting privilege count to 0
                    //adding privileges and incrementing counter
                            for (let l = 0; l < fieldEntity.privileges.length; l++) {
                                if (fieldEntity.privileges[l].PrivilegesValue == true) {
                                    selected.PrivilegeIds.push(fieldEntity.privileges[l].PrivilegeID);
                                    pCount = pCount + 1;
                                }
                            }

                            if (pCount != 0) {//at-least 1  privilege for this entity exists
                                roleVM.Selectedprivileges.push(angular.copy(selected));
                            }
                        }
                        for (let k = 0; k < roleVM.ReportEntities.length; k++) {
                            var reportEntity = roleVM.ReportEntities[k];
                            selected.EntityId = angular.copy(reportEntity.entityId);
                            selected.PrivilegeIds = [];
                            pCount = 0;//setting privilege count to 0
                    //adding privileges and incrementing counter
                            for (let l = 0; l < reportEntity.privileges.length; l++) {
                                if (reportEntity.privileges[l].PrivilegesValue == true) {
                                    selected.PrivilegeIds.push(reportEntity.privileges[l].PrivilegeID);
                                    pCount = pCount + 1;
                                }
                            }

                            if (pCount != 0) {//at-least 1  privilege for this entity exists
                                roleVM.Selectedprivileges.push(angular.copy(selected));
                            }
                        }

                //populating final save Privilege list//
                        if (roleVM.Selectedprivileges.length > 0) {
                            roleVM.Role.PrivilegeIdsPerEntity = angular.copy(roleVM.Selectedprivileges);
                        }
                        else {
                            roleVM.Role.PrivilegeIdsPerEntity = [];
                        }

                        roleVM.Role.EffectiveStartDate = tmxUtility.setStartDate(roleVM.Role.EffectiveStartDate).toJSON();
                        roleVM.Role.EffectiveEndDate = tmxUtility.setEndDate(roleVM.Role.EffectiveEndDate).toJSON();
                        roleVM.formInvalid = false;

                //////////////////////////////////////////SAVING///////////////////////////////////////////////////////////
                        roleVM.Role.$saveOrUpdate().then(function (response) {

                            $scope.dataLoading = false;
                            if (angular.isDefined($state.data.grid.roleGrid)) $state.data.grid.roleGrid.dataSource.read();
                            if (!angular.isDefined(response) || response == null) {
                                ToastService.showCustomToastomToast("error", "Some Error Occured");

                            }
                            else {//RESPONSE IS DEFINED
                                if (response.status >= 400) {
                                    roleVM.formSubmitted = false;
                                    var displayMsg = "";
                                    if (angular.isDefined(response.data.ModelState)) {
                                        var models = Object.keys(response.data.ModelState);
                                        models.forEach(function (key) {
                                            displayMsg += (response.data.ModelState[key])
                                        })
                                    }
                                    else
                                        displayMsg = response.data.Message;
                                    ToastService.showCustomToastomToast("error", displayMsg);
                                }
                                else {
                                    if (action == "save") {
                                //$state.go("^");
                                        $state.searchClear = true;
                                        $state.go('^', {}, { reload: true });
                                    }
                                    else if (action == "saveandnew") {
                                        $state.searchClear = true;
                                        $state.reload($state.current);
                                    }
                                }
                            }
                        });//end of .then
                    }
                };//end of save function

        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        ///////////////////////FUNCTION CALLED WHEN FILTER TRANSACTION TAB TEXT CHANGES////////////////////////////////////////
                roleVM.FilterMasterModules = function (text) {


                    var newMasterEntities = [];
                    if (angular.isDefined(text) && text != null && text != "") {
                //filter after comparison
                        for (let i = 0; i < roleVM.MasterEntitiesSource.length; i++) {
                            if (roleVM.MasterEntitiesSource[i].name.search(new RegExp(text, "i")) != -1) {
                        //transaction entity name is found
                                newMasterEntities.push(roleVM.MasterEntitiesSource[i]);
                            }
                        }
                        roleVM.MasterEntities = angular.copy(newMasterEntities);
                    }
                    else {

                        roleVM.MasterEntities = angular.copy(roleVM.MasterEntitiesSource);
                    }

                    for (var me = 0; me < roleVM.MasterEntities.length; me++) {
                        isEntityChecked(roleVM.MasterEntities[me]);

                    }
                    isMasterPrivilegeChecked();

                };
        //////////////////////////FUNCTION CALLED WHEN FILTER TRANSACTION TAB TEXT CHANGES//////////////////////////////////////
                roleVM.FilterTransactionModules = function (text) {


                    var newTransactionEntities = [];
                    if (angular.isDefined(text) && text != null && text != "") {
                //filter after comparison
                        for (let i = 0; i < roleVM.MenuEntitiesSource.length; i++) {
                            if (roleVM.MenuEntitiesSource[i].name.search(new RegExp(text, "i")) != -1) {
                        //transaction entity name is found
                                newTransactionEntities.push(roleVM.MenuEntitiesSource[i]);
                            }
                        }
                        roleVM.MenuEntities = angular.copy(newTransactionEntities);
                    }
                    else {

                        roleVM.MenuEntities = angular.copy(roleVM.MenuEntitiesSource);
                    }
                    for (var te = 0; te < roleVM.MenuEntities.length; te++) {
                        isEntityChecked(roleVM.MenuEntities[te]);

                    }
                    isTransactionPrivilegeChecked();
                };

                roleVM.FilterFieldsModules = function (text) {


                    var newFieldEntities = [];
                    if (angular.isDefined(text) && text != null && text != "") {
                //filter after comparison
                        for (let i = 0; i < roleVM.FieldEntitiesSource.length; i++) {
                            if (roleVM.FieldEntitiesSource[i].name.search(new RegExp(text, "i")) != -1) {
                        //transaction entity name is found
                                newFieldEntities.push(roleVM.FieldEntitiesSource[i]);
                            }
                        }
                        roleVM.FieldEntities = angular.copy(newFieldEntities);
                    }
                    else {

                        roleVM.FieldEntities = angular.copy(roleVM.FieldEntitiesSource);
                    }
                    for (var te = 0; te < roleVM.FieldEntities.length; te++) {
                        isEntityChecked(roleVM.FieldEntities[te]);

                    }
                    isFieldPrivilegeChecked();
                };

                roleVM.FilterReportModules = function(text){
                    var newReportEntities = [];
                    if (angular.isDefined(text) && text != null && text != "") {
                //filter after comparison
                        for (let i = 0; i < roleVM.ReportEntitiesSource.length; i++) {
                            if (roleVM.ReportEntitiesSource[i].name.search(new RegExp(text, "i")) != -1) {
                        //transaction entity name is found
                                newReportEntities.push(roleVM.ReportEntitiesSource[i]);
                            }
                        }
                        roleVM.ReportEntities = angular.copy(newReportEntities);
                    }
                    else {

                        roleVM.ReportEntities = angular.copy(roleVM.ReportEntitiesSource);
                    }
                    for (var te = 0; te < roleVM.FieldEntities.length; te++) {
                        isEntityChecked(roleVM.ReportEntities[te]);

                    }
                    isReportPrivilegeChecked();
                }

        //////////////////////////////////PRIVILEGE VALIDATION/////////////////////////////////////////////////////////////////
                $scope.validatePrivileges = function () {
                    for (let i = 0; i < roleVM.MasterEntitiesSource.length; i++) {
                        var entity = roleVM.MasterEntitiesSource[i];
                        for (let j = 0; j < entity.privileges.length - 1; j++) {
                            if (entity.privileges[j].PrivilegesValue) {
                                return true;
                            }
                        }
                    }
                    for (let k = 0; k < roleVM.MenuEntitiesSource.length; k++) {
                        var transaction = roleVM.MenuEntitiesSource[k];
                        for (var l = 0; l < transaction.privileges.length - 1; l++) {
                            if (transaction.privileges[l].PrivilegesValue) {
                                return true;
                            }
                        }
                    }
                    return false;
                };

        ////////////////////////////////DATE START SELECTED//////////////////////////////////////////////////////////////////
                roleVM.onStartDateSelected = function (selectedDate) {
                    if (selectedDate != null) {
                        roleVM.Role.EffectiveStartDate = tmxUtility.setStartDate(selectedDate).toJSON();//start Date
                        roleVM.StartDateInvalid = false;
                        roleVM.minEndDate = roleVM.Role.EffectiveStartDate;//ensuring that end date >= start Date
                    }
                    else {
                        roleVM.StartDateInvalid = true;
                    }
                };
        ////////////////////////////////DATE END VALIDATION//////////////////////////////////////////////////////////////////
                roleVM.onEndDateSelected = function (selectedDate) {
                    if (selectedDate != null) {
                        roleVM.Role.EffectiveEndDate = tmxUtility.setEndDate(selectedDate).toJSON();//end Date
                        roleVM.EndDateInvalid = false;
                    }
                    else {
                        roleVM.EndDateInvalid = true;
                    }
                };
        ///////////////////////////////////////////PRIVILEGES/////////////////////////////////////////////////////////////////
        /////////////////////////////////////IS ALL PRIVILEGES (MASTER/TRANSACTION) CHECKED////////////////////////////////////
                function isAllPrivilegeChecked() {

                    roleVM.AllPrivilegesChecked = true;
                    roleVM.AllTransPrivilegesChecked = true;
                    roleVM.AllFieldPrivilegesChecked = true;
                    roleVM.AllReportPrivilegesChecked = true;
                    for (var mp = 0; mp < roleVM.MasterPrivileges.length; mp++) {
                        if (roleVM.MasterPrivileges[mp].PrivilegesValue == false) {
                            roleVM.AllPrivilegesChecked = false;
                        }
                    }
                    for (var tp = 0; tp < roleVM.MenuPrivileges.length; tp++) {
                        if (roleVM.MenuPrivileges[tp].PrivilegesValue == false) {
                            roleVM.AllTransPrivilegesChecked = false;
                        }
                    }
                    for (var fp = 0; fp < roleVM.FieldPrivileges.length; fp++) {
                        if (roleVM.FieldPrivileges[fp].PrivilegesValue == false) {
                            roleVM.AllFieldPrivilegesChecked = false;
                        }
                    }
                    for (let fp = 0; fp < roleVM.ReportPrivileges.length; fp++) {
                        if (roleVM.ReportPrivileges[fp].PrivilegesValue == false) {
                            roleVM.AllReportPrivilegesChecked = false;
                        }
                    }
                }
        /////////////////////IS ALL MODULE (MASTER/TRANSACTION) CHECKED/////////////////////////////////////////////////////////
                function isAllModuleChecked() {
                    roleVM.entityMasterCheckCount = 0;
                    roleVM.entityTransCheckCount = 0;
                    roleVM.entityFieldCheckCount = 0;
                    roleVM.entityReportCheckCount = 0;


                    for (let i = 0; i < roleVM.MasterEntities.length; i++) {
                        if (roleVM.MasterEntities[i].isChecked) {
                            roleVM.entityMasterCheckCount++;
                        }
                    }

                    for (let j = 0; j < roleVM.MenuEntities.length; j++) {
                        if (roleVM.MenuEntities[j].isChecked) {
                            roleVM.entityTransCheckCount++;
                        }
                    }
                    for (let j = 0; j < roleVM.FieldEntities.length; j++) {
                        if (roleVM.FieldEntities[j].isChecked) {
                            roleVM.entityFieldCheckCount++;
                        }
                    }
                    for (let j = 0; j < roleVM.ReportEntities.length; j++) {
                        if (roleVM.ReportEntities[j].isChecked) {
                            roleVM.entityReportCheckCount++;
                        }
                    }
            //checking all Entity check
                    if (roleVM.entityMasterCheckCount == roleVM.MasterEntities.length) {
                        roleVM.allEntitiesChecked = true;
                //roleVM.AllPrivilegesChecked = true;

                    }
                    else {
                        roleVM.allEntitiesChecked = false;
                //roleVM.AllPrivilegesChecked = false;
                    }


                    if (roleVM.entityTransCheckCount == roleVM.MenuEntities.length) {//all transactions checked
                        roleVM.allTransactionsChecked = true;
                    }
                    else {
                        roleVM.allTransactionsChecked = false;
                    }

                    if (roleVM.entityFieldCheckCount == roleVM.FieldEntities.length) {//all Fields checked
                        roleVM.allFieldsChecked = true;
                    }
                    else {
                        roleVM.allFieldsChecked = false;
                    }

                    if (roleVM.entityReportCheckCount == roleVM.ReportEntities.length) {//all Reports checked
                        roleVM.allReportsChecked = true;
                    }
                    else {
                        roleVM.allReportsChecked = false;
                    }
                }
        ///////////////////////////////// IS SINGLE ENTITY (MASTER/TRANSACTION) CHECKED//////////////////////////////////////////
                function isEntityChecked(entity) {

                    var entityPrivCount = 0;
                    for (let i = 0; i < entity.privileges.length - 1; i++) {
                        if (entity.privileges[i].PrivilegesValue) {
                            entityPrivCount++;
                        }
                //else{
                //    entityPrivCount--;
                //}
                    }

                    if (entityPrivCount <= (entity.privileges.length - 1) && entityPrivCount != 0) { //at-least one child privilege checked
                        entity.isChecked = true;

                    }
                    else if (entityPrivCount == 0) {
                        entity.isChecked = false;
                    }
            //check if all entities are checked//
                    isAllModuleChecked();


                }
        //////////////////////////////////// IS SINGLE MASTER PRIVILEGE CHECKED////////////////////////////////////////////////
                function isMasterPrivilegeChecked() {


                    for (var mp = 0; mp < roleVM.MasterPrivileges.length ; mp++) {
                        if (roleVM.MasterPrivileges[mp].EntityCount == roleVM.MasterEntitiesSource.length) {
                            roleVM.MasterPrivileges[mp].PrivilegesValue = true;

                        }
                        else {
                            roleVM.MasterPrivileges[mp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();

                }
        //////////////////////////////////////IS SINGLE TRANSACTION PRIVILEGE CHECKED/////////////////////////////////////////
                function isTransactionPrivilegeChecked() {
                    for (var tp = 0; tp < roleVM.MenuPrivileges.length; tp++) {
                        if (roleVM.MenuPrivileges[tp].EntityCount == roleVM.MenuEntitiesSource.length) {
                            roleVM.MenuPrivileges[tp].PrivilegesValue = true;
                        }
                        else {
                            roleVM.MenuPrivileges[tp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();
                }

                function isFieldPrivilegeChecked() {
                    for (var tp = 0; tp < roleVM.FieldPrivileges.length; tp++) {
                        if (roleVM.FieldPrivileges[tp].EntityCount == roleVM.FieldEntitiesSource.length) {
                            roleVM.FieldPrivileges[tp].PrivilegesValue = true;
                        }
                        else {
                            roleVM.FieldPrivileges[tp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();
                }

                function isReportPrivilegeChecked() {
                    for (var tp = 0; tp < roleVM.ReportPrivileges.length; tp++) {
                        if (roleVM.ReportPrivileges[tp].EntityCount == roleVM.ReportEntitiesSource.length) {
                            roleVM.ReportPrivileges[tp].PrivilegesValue = true;
                        }
                        else {
                            roleVM.ReportPrivileges[tp].PrivilegesValue = false;
                        }
                    }
                    isAllPrivilegeChecked();
                }

        
        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////POPULATE PRIVILEGE FUNCTION on EDIT /////////////////////////////////
                function populateEntityPrivilegeArray(privilegeArr, entity) {
                    var fullPrivilegeArr = [];

                    if (entity.entityType == "MasterData") {
                        fullPrivilegeArr = angular.copy(roleVM.MasterPrivileges);
                    }
                    else if (entity.entityType == "Menu") {
                        fullPrivilegeArr = angular.copy(roleVM.MenuPrivileges);
                    }
                    else if (entity.entityType == "Field") {
                        fullPrivilegeArr = angular.copy(roleVM.FieldPrivileges);
                    }
                    else if (entity.entityType == "Report") {
                        fullPrivilegeArr = angular.copy(roleVM.ReportPrivileges);
                    }

            //for(let k=0;k<fullPrivilegeArr.length;k++){
            //    fullPrivilegeArr[k].PrivilegesValue =false; //by default unselected
            //}
                    var countPCheck = 0;


                    for (let i = 0; i < privilegeArr.length; i++) {//privilege array passed in for selected privileges of entity

                        for (let j = 0; j < fullPrivilegeArr.length; j++) {//total privileges
                            if (privilegeArr[i] == fullPrivilegeArr[j].PrivilegeID) {//if privilege id is found

                                fullPrivilegeArr[j].PrivilegesValue = true;//checking individual privilege value per entity
                                countPCheck = countPCheck + 1;

                                if (entity.entityType == "MasterData") {
                                    roleVM.MasterPrivileges[j].EntityCount = roleVM.MasterPrivileges[j].EntityCount + 1;
                                }
                                else if (entity.entityType == "Menu") {
                                    roleVM.MenuPrivileges[j].EntityCount = roleVM.MenuPrivileges[j].EntityCount + 1;
                                }
                                else if (entity.entityType == "Field") {
                                    roleVM.FieldPrivileges[j].EntityCount = roleVM.FieldPrivileges[j].EntityCount + 1;
                                }
                                else if (entity.entityType == "Report") {
                                    roleVM.ReportPrivileges[j].EntityCount = roleVM.ReportPrivileges[j].EntityCount + 1;
                                }
                            }

                        }

                    }
                    if (entity.entityType == "MasterData") {
                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {//all Master privilege for this entity are checked
                            entity.isChecked = true;
                            roleVM.entityMasterCheckCount = roleVM.entityMasterCheckCount + 1;

                        }
                    }
                    else if (entity.entityType == "Menu") {

                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {//all 7 privileges checked for this Transaction entity
                            entity.isChecked = true;
                            roleVM.entityTransCheckCount = roleVM.entityTransCheckCount + 1;
                        }

                    }
                    else if (entity.entityType == "Field") {

                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {//all 7 privileges checked for this Transaction entity
                            entity.isChecked = true;
                            roleVM.entityFieldCheckCount = roleVM.entityFieldCheckCount + 1;
                        }

                    }
                    else if (entity.entityType == "Report") {

                        if (countPCheck > 0 && countPCheck <= fullPrivilegeArr.length) {
                            entity.isChecked = true;
                            roleVM.entityFieldCheckCount = roleVM.entityFieldCheckCount + 1;
                        }

                    }

                    return fullPrivilegeArr;
                }
        //////////////////////////////////EDIT ROLE FUNCTION TO POPULATE CHECKED PRIVILEGES/////////////////////////////////////
                function populatePrivileges() {
                    roleVM.entityMasterCheckCount = 0;
                    roleVM.entityTransCheckCount = 0;
                    roleVM.entityFieldCheckCount = 0;
                    roleVM.entityReportCheckCount = 0;


                    roleVM.Selectedprivileges = [];
                    if (angular.isDefined(roleVM.Role.PrivilegeIdsPerEntity)) {
                        roleVM.Selectedprivileges = angular.copy(roleVM.Role.PrivilegeIdsPerEntity);
                    }

            //looping through selected privilege array//
                    for (let j = 0; j < roleVM.Selectedprivileges.length; j++) {
                        var entity = roleVM.Selectedprivileges[j];

                        for (var m = 0; m < roleVM.MasterEntities.length; m++) {
                            if (entity.EntityId == roleVM.MasterEntities[m].entityId) {
                        //privileges.push(angular.copy(entity.PrivilegeIds));
                                roleVM.MasterEntities[m].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.MasterEntities[m]));

                            }
                        }

                        for (let t  = 0; t < roleVM.MenuEntities.length; t++) {
                            if (entity.EntityId == roleVM.MenuEntities[t].entityId) {
                                roleVM.MenuEntities[t].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.MenuEntities[t]));
                            }
                        }

                        for (let f = 0; f < roleVM.FieldEntities.length; f++) {
                            if (entity.EntityId == roleVM.FieldEntities[f].entityId) {
                                roleVM.FieldEntities[f].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.FieldEntities[f]));
                            }
                        }

                        for (let f = 0; f < roleVM.ReportEntities.length; f++) {
                            if (entity.EntityId == roleVM.ReportEntities[f].entityId) {
                                roleVM.ReportEntities[f].privileges = angular.copy(populateEntityPrivilegeArray(angular.copy(entity.PrivilegeIds), roleVM.ReportEntities[f]));
                            }
                        }

                    }
            //checking Master privilege in right side panel
                    isMasterPrivilegeChecked();
            //checking Transaction privileges in right side panel
                    isTransactionPrivilegeChecked();

                    isFieldPrivilegeChecked();

                    isReportPrivilegeChecked();

            //checking all Entity check
                    if (roleVM.entityMasterCheckCount == roleVM.MasterEntities.length) {
                        roleVM.allEntitiesChecked = true;
                //roleVM.AllPrivilegesChecked =true;
                    }
                    if (roleVM.entityTransCheckCount == roleVM.MenuEntities.length) {//all transactions checked
                        roleVM.allTransactionsChecked = true;
                //roleVM.AllTransPrivilegesChecked =true;
                    }
                    if (roleVM.entityFieldCheckCount == roleVM.FieldEntities.length) {//all field checked
                        roleVM.allFieldsChecked = true;
                //roleVM.AllTransPrivilegesChecked =true;
                    }
                    if (roleVM.entityReportCheckCount == roleVM.ReportEntities.length) {//all field checked
                        roleVM.allReportsChecked = true;
                //roleVM.AllTransPrivilegesChecked =true;
                    }
                    roleVM.MasterEntitiesSource = angular.copy(roleVM.MasterEntities);
                    roleVM.MenuEntitiesSource = angular.copy(roleVM.MenuEntities);
                    roleVM.FieldEntitiesSource = angular.copy(roleVM.FieldEntities);
                    roleVM.ReportEntitiesSource = angular.copy(roleVM.ReportEntities);


                }//function end

        //////////////////////////////// FE CHECK FUNCTIONS/////////////////////////////////////////////////////////////////////
        ///////////////////////////////////////// TOGGLE INDIVIDUAL CHECKS//////////////////////////////////////////////////////
                roleVM.toggle = function (entity, privilege) {
                    for (let i = 0; i < entity.privileges.length; i++) {
                        if (entity.privileges[i].PrivilegeID == privilege.PrivilegeID) {
                            entity.privileges[i].PrivilegesValue = !entity.privileges[i].PrivilegesValue;


                            if (entity.entityType == "MasterData") {

                                if (entity.privileges[i].PrivilegesValue) {
                                    roleVM.MasterPrivileges[i].EntityCount++;
                                }
                                else {
                                    roleVM.MasterPrivileges[i].EntityCount--;
                                }
                            }
                            else if (entity.entityType == "Menu") {
                                if (entity.privileges[i].PrivilegesValue) {
                                    roleVM.MenuPrivileges[i].EntityCount++;
                                }
                                else {
                                    roleVM.MenuPrivileges[i].EntityCount--;
                                }
                            }
                            else if (entity.entityType == "Field") {
                                if (entity.privileges[i].PrivilegesValue) {
                                    roleVM.FieldPrivileges[i].EntityCount++;
                                }
                                else {
                                    roleVM.FieldPrivileges[i].EntityCount--;
                                }
                            }

                        }

                    }//for loop on entity privileges
            //checking if whole entity is checked

                    isEntityChecked(entity);
                    if (entity.entityType == "MasterData") {
                        isMasterPrivilegeChecked();
                    }
                    else if (entity.entityType == "Menu") {
                        isTransactionPrivilegeChecked();
                    }
                    else if (entity.entityType == "Field") {
                        isFieldPrivilegeChecked();
                    }
                    else if (entity.entityType == "Report") {
                        isReportPrivilegeChecked();
                    }
            //////////////////////////////////////////////////////////////////////////////////////////////////////////
            //update MasterEntitySource for that entity only
                    if (!angular.equals(roleVM.MasterEntities, roleVM.MasterEntitiesSource)) {
                        for (var s = 0; s < roleVM.MasterEntitiesSource.length; s++) {
                            if (entity.name == roleVM.MasterEntitiesSource[s].name) {
                                roleVM.MasterEntitiesSource.splice(s, 1, entity);
                            }
                        }
                    }
            //update TransactionEntitySource
                    if (!angular.equals(roleVM.MenuEntities, roleVM.MenuEntitiesSource)) {
                        for (let t  = 0; t < roleVM.MenuEntitiesSource.length; t++) {
                            if (entity.name == roleVM.MenuEntitiesSource[t].name) {
                                roleVM.MenuEntitiesSource.splice(t, 1, entity);
                            }
                        }
                    }
                    if (!angular.equals(roleVM.FieldEntities, roleVM.FieldEntitiesSource)) {
                        for (let t  = 0; t < roleVM.FieldEntitiesSource.length; t++) {
                            if (entity.name == roleVM.FieldEntitiesSource[t].name) {
                                roleVM.FieldEntitiesSource.splice(t, 1, entity);
                            }
                        }
                    }
                    if (!angular.equals(roleVM.ReportEntities, roleVM.ReportEntitiesSource)) {
                        for (let t  = 0; t < roleVM.ReportEntitiesSource.length; t++) {
                            if (entity.name == roleVM.ReportEntitiesSource[t].name) {
                                roleVM.ReportEntitiesSource.splice(t, 1, entity);
                            }
                        }
                    }

            //validation Master privilege
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };
        //////////////////////// CHECK INDIVIDUAL ENTITY////////////////////////////////////////////////////////////////////////
                roleVM.checkEntity = function (entity) {

                    for (let i = 0; i < entity.privileges.length; i++) {
                        if (entity.privileges[i].PrivilegesValue != entity.isChecked) {
                            entity.privileges[i].PrivilegesValue = entity.isChecked;
                            if (entity.privileges[i].PrivilegesValue) {
                                roleVM.MasterPrivileges[i].EntityCount++;
                            }
                            else {
                                roleVM.MasterPrivileges[i].EntityCount--;
                            }

                        }
                    }
                    isAllModuleChecked();
                    isMasterPrivilegeChecked();

            //update MasterEntitySource for that entity only//
                    if (!angular.equals(roleVM.MasterEntities, roleVM.MasterEntitiesSource)) {
                        for (var s = 0; s < roleVM.MasterEntitiesSource.length; s++) {
                            if (entity.name == roleVM.MasterEntitiesSource[s].name) {
                                roleVM.MasterEntitiesSource.splice(s, 1, entity);
                            }
                        }
                    }
            //validation Master privilege
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();

                };
                roleVM.checkTransaction = function (entity) {

                    for (let i = 0; i < entity.privileges.length; i++) {
                        if (entity.privileges[i].PrivilegesValue != entity.isChecked) {
                            entity.privileges[i].PrivilegesValue = entity.isChecked;
                            if (entity.privileges[i].PrivilegesValue) {
                                roleVM.MenuPrivileges[i].EntityCount++;
                            }
                            else {
                                roleVM.MenuPrivileges[i].EntityCount--;
                            }
                        }
                    }
                    isAllModuleChecked();
                    isTransactionPrivilegeChecked();
            //update TransactionEntitySource
                    if (!angular.equals(roleVM.MenuEntities, roleVM.MenuEntitiesSource)) {
                        for (let t  = 0; t < roleVM.MenuEntitiesSource.length; t++) {
                            if (entity.name == roleVM.MenuEntitiesSource[t].name) {
                                roleVM.MenuEntitiesSource.splice(t, 1, entity);
                            }
                        }
                    }
            //validation Master privilege
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };

                roleVM.checkField = function (entity) {

                    for (let i = 0; i < entity.privileges.length; i++) {
                        if (entity.privileges[i].PrivilegesValue != entity.isChecked) {
                            entity.privileges[i].PrivilegesValue = entity.isChecked;
                            if (entity.privileges[i].PrivilegesValue) {
                                roleVM.FieldPrivileges[i].EntityCount++;
                            }
                            else {
                                roleVM.FieldPrivileges[i].EntityCount--;
                            }
                        }
                    }
                    isAllModuleChecked();
                    isFieldPrivilegeChecked();
            //update TransactionEntitySource
                    if (!angular.equals(roleVM.FieldEntities, roleVM.FieldEntitiesSource)) {
                        for (let t  = 0; t < roleVM.FieldEntitiesSource.length; t++) {
                            if (entity.name == roleVM.FieldEntitiesSource[t].name) {
                                roleVM.FieldEntitiesSource.splice(t, 1, entity);
                            }
                        }
                    }
            //validation Master privilege
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };

                roleVM.checkReport = function (entity) {

                    for (let i = 0; i < entity.privileges.length; i++) {
                        if (entity.privileges[i].PrivilegesValue != entity.isChecked) {
                            entity.privileges[i].PrivilegesValue = entity.isChecked;
                            if (entity.privileges[i].PrivilegesValue) {
                                roleVM.ReportPrivileges[i].EntityCount++;
                            }
                            else {
                                roleVM.ReportPrivileges[i].EntityCount--;
                            }
                        }
                    }
                    isAllModuleChecked();
                    isReportPrivilegeChecked();
            //update TransactionEntitySource
                    if (!angular.equals(roleVM.ReportEntities, roleVM.ReportEntitiesSource)) {
                        for (let t  = 0; t < roleVM.ReportEntitiesSource.length; t++) {
                            if (entity.name == roleVM.ReportEntitiesSource[t].name) {
                                roleVM.ReportEntitiesSource.splice(t, 1, entity);
                            }
                        }
                    }
            //validation Master privilege
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };
        ////////////////////////FUNCTION CALLED WHEN CHECK ALL MASTER MODULES OR ALL MASTER PRIVILEGES IS CHECKED///////////////
                roleVM.checkAll = function (AllChecked) {
                    roleVM.allEntitiesChecked = AllChecked;
                    roleVM.AllPrivilegesChecked = AllChecked;
            //master entities check//

                    for (let i = 0; i < roleVM.MasterEntities.length; i++) {
                        roleVM.MasterEntities[i].isChecked = AllChecked;
                        for (let j = 0; j < roleVM.MasterEntities[i].privileges.length; j++) {
                            roleVM.MasterEntities[i].privileges[j].PrivilegesValue = AllChecked;

                        }
                //update MasterEntitySource for that entity only//
                        for (var me = 0; me < roleVM.MasterEntitiesSource.length; me++) {
                            if (!angular.equals(roleVM.MasterEntities[i], roleVM.MasterEntitiesSource[me]) &&
                        roleVM.MasterEntities[i].name == roleVM.MasterEntitiesSource[me].name
                            ) {
                                roleVM.MasterEntitiesSource.splice(me, 1, roleVM.MasterEntities[i]);
                            }
                        }

                    }

            //all privileges checked in side panel//
                    for (let i = 0; i < roleVM.MasterPrivileges.length; i++) {
                        roleVM.MasterPrivileges[i].PrivilegesValue = AllChecked;
                        if (AllChecked) {
                            roleVM.MasterPrivileges[i].EntityCount = roleVM.MasterEntitiesSource.length;
                        }
                        else {
                            roleVM.MasterPrivileges[i].EntityCount = 0;
                        }
                    }
            //validation Master privilege
                    if (AllChecked) {
                        roleVM.validationMasterPrivilege = true;
                    }
                    else {
                        roleVM.validationMasterPrivilege = false;
                    }


                };
        ///////////////////////////FUNCTION CALLED WHEN CHECK ALL TRANSACTION MODULES OR ALL PRIVILEGES IS CHECKED/////////////
                roleVM.checkAllTransactions = function (AllChecked) {
                    roleVM.allTransactionsChecked = AllChecked;
                    roleVM.AllTransPrivilegesChecked = AllChecked;
            //transaction entities check//
                    for (let i = 0; i < roleVM.MenuEntities.length; i++) {
                        roleVM.MenuEntities[i].isChecked = AllChecked;
                        for (let j = 0; j < roleVM.MenuEntities[i].privileges.length; j++) {
                            roleVM.MenuEntities[i].privileges[j].PrivilegesValue = AllChecked;

                        }
                //update TransactionEntitySource for that entity only//
                        for (var te = 0; te < roleVM.MenuEntitiesSource.length; te++) {
                            if (!angular.equals(roleVM.MenuEntities[i], roleVM.MenuEntitiesSource[te]) &&
                        roleVM.MenuEntities[i].name == roleVM.MenuEntitiesSource[te].name
                            ) {
                                roleVM.MenuEntitiesSource.splice(te, 1, roleVM.MenuEntities[i]);
                            }
                        }

                    }

            //all privileges checked in side panel//
                    for (let i = 0; i < roleVM.MenuPrivileges.length; i++) {
                        roleVM.MenuPrivileges[i].PrivilegesValue = AllChecked;
                        if (AllChecked) {
                            roleVM.MenuPrivileges[i].EntityCount = roleVM.MenuEntitiesSource.length;
                        }
                        else {
                            roleVM.MenuPrivileges[i].EntityCount = 0;
                        }
                    }

                    if (AllChecked) {
                        roleVM.validationMasterPrivilege = true;
                    }
                    else {
                        roleVM.validationMasterPrivilege = false;
                    }
                };
                roleVM.checkAllFields = function (AllChecked) {
                    roleVM.allFieldsChecked = AllChecked;
                    roleVM.AllFieldPrivilegesChecked = AllChecked;
            //transaction entities check//
                    for (let i = 0; i < roleVM.FieldEntities.length; i++) {
                        roleVM.FieldEntities[i].isChecked = AllChecked;
                        for (let j = 0; j < roleVM.FieldEntities[i].privileges.length; j++) {
                            roleVM.FieldEntities[i].privileges[j].PrivilegesValue = AllChecked;

                        }
                //update TransactionEntitySource for that entity only//
                        for (var te = 0; te < roleVM.FieldEntitiesSource.length; te++) {
                            if (!angular.equals(roleVM.FieldEntities[i], roleVM.FieldEntitiesSource[te]) &&
                        roleVM.FieldEntities[i].name == roleVM.FieldEntitiesSource[te].name
                            ) {
                                roleVM.FieldEntitiesSource.splice(te, 1, roleVM.FieldEntities[i]);
                            }
                        }

                    }

            //all privileges checked in side panel//
                    for (let i = 0; i < roleVM.FieldPrivileges.length; i++) {
                        roleVM.FieldPrivileges[i].PrivilegesValue = AllChecked;
                        if (AllChecked) {
                            roleVM.FieldPrivileges[i].EntityCount = roleVM.FieldEntitiesSource.length;
                        }
                        else {
                            roleVM.FieldPrivileges[i].EntityCount = 0;
                        }
                    }

                    if (AllChecked) {
                        roleVM.validationMasterPrivilege = true;
                    }
                    else {
                        roleVM.validationMasterPrivilege = false;
                    }
                };
                roleVM.checkAllReports = function (AllChecked) {
                    roleVM.allReportsChecked = AllChecked;
                    roleVM.AllReportPrivilegesChecked = AllChecked;
            //transaction entities check//
                    for (let i = 0; i < roleVM.ReportEntities.length; i++) {
                        roleVM.ReportEntities[i].isChecked = AllChecked;
                        for (let j = 0; j < roleVM.ReportEntities[i].privileges.length; j++) {
                            roleVM.ReportEntities[i].privileges[j].PrivilegesValue = AllChecked;

                        }
                //update TransactionEntitySource for that entity only//
                        for (var te = 0; te < roleVM.ReportEntitiesSource.length; te++) {
                            if (!angular.equals(roleVM.ReportEntities[i], roleVM.ReportEntitiesSource[te]) &&
                        roleVM.ReportEntities[i].name == roleVM.ReportEntitiesSource[te].name
                            ) {
                                roleVM.ReportEntitiesSource.splice(te, 1, roleVM.ReportEntities[i]);
                            }
                        }

                    }

            //all privileges checked in side panel//
                    for (let i = 0; i < roleVM.ReportPrivileges.length; i++) {
                        roleVM.ReportPrivileges[i].PrivilegesValue = AllChecked;
                        if (AllChecked) {
                            roleVM.ReportPrivileges[i].EntityCount = roleVM.ReportEntitiesSource.length;
                        }
                        else {
                            roleVM.ReportPrivileges[i].EntityCount = 0;
                        }
                    }

                    if (AllChecked) {
                        roleVM.validationMasterPrivilege = true;
                    }
                    else {
                        roleVM.validationMasterPrivilege = false;
                    }
                };
        ///////////////////////// FUNCTION CALLED WHEN INDIVIDUAL PRIVILEGE CHECKED IN SIDE PANEL///////////////////////////////
                roleVM.checkPrivilege = function (privilege) {

                    for (let i = 0; i < roleVM.MasterEntities.length; i++) {
                        for (let j = 0; j < roleVM.MasterEntities[i].privileges.length; j++) {
                            if (privilege.PrivilegeID == roleVM.MasterEntities[i].privileges[j].PrivilegeID) {
                                if (roleVM.MasterEntities[i].privileges[j].PrivilegesValue != privilege.PrivilegesValue) {
                                    if (privilege.PrivilegesValue) {
                                        roleVM.MasterPrivileges[j].EntityCount++;
                                    }
                                    else {
                                        roleVM.MasterPrivileges[j].EntityCount--;
                                    }
                                }
                                roleVM.MasterEntities[i].privileges[j].PrivilegesValue = privilege.PrivilegesValue;
                            }
                        }

                    }

                    isAllPrivilegeChecked();
                    for (var me = 0; me < roleVM.MasterEntities.length; me++) {

                        isEntityChecked(roleVM.MasterEntities[me]);
                //update MasterEntitySource for that entity only//
                        for (var mse = 0; mse < roleVM.MasterEntitiesSource.length; mse++) {
                            if (!angular.equals(roleVM.MasterEntities[me], roleVM.MasterEntitiesSource[mse]) &&
                        roleVM.MasterEntities[me].name == roleVM.MasterEntitiesSource[mse].name
                            ) {
                                roleVM.MasterEntitiesSource.splice(mse, 1, roleVM.MasterEntities[me]);
                            }
                        }

                    }


                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();


                };
        ///////////////////////// FUNCTION CALLED WHEN INDIVIDUAL TRANSACTION PRIVILEGE CHECKED IN SIDE PANEL///////////////////
                roleVM.checkTransactionPrivilege = function (privilege) {

                    for (let i = 0; i < roleVM.MenuEntities.length; i++) {
                        for (let j = 0; j < roleVM.MenuEntities[i].privileges.length; j++) {
                            if (privilege.PrivilegeID == roleVM.MenuEntities[i].privileges[j].PrivilegeID) {
                                if (roleVM.MenuEntities[i].privileges[j].PrivilegesValue != privilege.PrivilegesValue) {
                                    if (privilege.PrivilegesValue) {
                                        roleVM.MenuPrivileges[j].EntityCount++;
                                    }
                                    else {
                                        roleVM.MenuPrivileges[j].EntityCount--;
                                    }
                                }
                                roleVM.MenuEntities[i].privileges[j].PrivilegesValue = privilege.PrivilegesValue;
                            }
                        }

                    }
                    isAllPrivilegeChecked();
                    for (var te = 0; te < roleVM.MenuEntities.length; te++) {

                        isEntityChecked(roleVM.MenuEntities[te]);
                //update TransactionEntitySource for that entity only//
                        for (var tes = 0; tes < roleVM.MenuEntitiesSource.length; tes++) {
                            if (!angular.equals(roleVM.MenuEntities[te], roleVM.MenuEntitiesSource[tes]) &&
                        roleVM.MenuEntities[te].name == roleVM.MenuEntitiesSource[tes].name
                            ) {
                                roleVM.MenuEntitiesSource.splice(tes, 1, roleVM.MenuEntities[te]);
                            }
                        }

                    }
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };
                roleVM.checkFieldPrivilege = function (privilege) {

                    for (let i = 0; i < roleVM.FieldEntities.length; i++) {
                        for (let j = 0; j < roleVM.FieldEntities[i].privileges.length; j++) {
                            if (privilege.PrivilegeID == roleVM.FieldEntities[i].privileges[j].PrivilegeID) {
                                if (roleVM.FieldEntities[i].privileges[j].PrivilegesValue != privilege.PrivilegesValue) {
                                    if (privilege.PrivilegesValue) {
                                        roleVM.FieldEntities[j].EntityCount++;
                                    }
                                    else {
                                        roleVM.FieldEntities[j].EntityCount--;
                                    }
                                }
                                roleVM.FieldEntities[i].privileges[j].PrivilegesValue = privilege.PrivilegesValue;
                            }
                        }

                    }
                    isAllPrivilegeChecked();
                    for (var te = 0; te < roleVM.FieldEntities.length; te++) {

                        isEntityChecked(roleVM.FieldEntities[te]);
                //update TransactionEntitySource for that entity only//
                        for (var tes = 0; tes < roleVM.FieldEntitiesSource.length; tes++) {
                            if (!angular.equals(roleVM.FieldEntities[te], roleVM.FieldEntitiesSource[tes]) &&
                        roleVM.FieldEntities[te].name == roleVM.FieldEntitiesSource[tes].name
                            ) {
                                roleVM.FieldEntitiesSource.splice(tes, 1, roleVM.FieldEntities[te]);
                            }
                        }

                    }
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };
                roleVM.checkReportPrivilege = function (privilege) {

                    for (let i = 0; i < roleVM.ReportEntities.length; i++) {
                        for (let j = 0; j < roleVM.ReportEntities[i].privileges.length; j++) {
                            if (privilege.PrivilegeID == roleVM.ReportEntities[i].privileges[j].PrivilegeID) {
                                if (roleVM.ReportEntities[i].privileges[j].PrivilegesValue != privilege.PrivilegesValue) {
                                    if (privilege.PrivilegesValue) {
                                        roleVM.ReportEntities[j].EntityCount++;
                                    }
                                    else {
                                        roleVM.ReportEntities[j].EntityCount--;
                                    }
                                }
                                roleVM.ReportEntities[i].privileges[j].PrivilegesValue = privilege.PrivilegesValue;
                            }
                        }

                    }
                    isAllPrivilegeChecked();
                    for (var te = 0; te < roleVM.ReportEntities.length; te++) {

                        isEntityChecked(roleVM.ReportEntities[te]);
                //update TransactionEntitySource for that entity only//
                        for (var tes = 0; tes < roleVM.ReportEntitiesSource.length; tes++) {
                            if (!angular.equals(roleVM.ReportEntities[te], roleVM.ReportEntitiesSource[tes]) &&
                        roleVM.ReportEntities[te].name == roleVM.ReportEntitiesSource[tes].name
                            ) {
                                roleVM.ReportEntitiesSource.splice(tes, 1, roleVM.ReportEntities[te]);
                            }
                        }

                    }
                    roleVM.validationMasterPrivilege = $scope.validatePrivileges();
                };
        ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            }]);//controller function end
})();

